import React, { useEffect } from 'react';
import Navbar from '../../layout/Navbar';
import Footer from '../../layout/Footer';
import Hero from './Hero';
import StatsBar from './StatsBar';
import ValueProps from './ValueProps';
import SafetySection from './SafetySection';
import ServicesSection from './ServicesSection';
import FleetShowcase from './FleetShowcase';
import TechSection from './TechSection';
import PricingSection from './PricingSection';
import CoverageSection from './CoverageSection';
import FAQSection from './FAQSection';
import Testimonials from './Testimonials';
import SectionTransition from './SectionTransition';
import SEO, { getSEOData } from '../../components/SEO';
import Schema from '../../components/Schema';

const Corporate = () => {
  const seo = getSEOData('corporate');

  useEffect(() => {
    // Scroll to top when the pathname changes
    window.scrollTo(0, 0);
  }, []);

  // Material Symbols is a large variable icon font and these are the only pages
  // that use it, so it is no longer in index.html. Inject it here rather than
  // making every visitor pay for it.
  useEffect(() => {
    const HREF =
      'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200'
    if (document.querySelector(`link[href="${HREF}"]`)) return
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = HREF
    document.head.appendChild(link)
  }, []);

  return (
    <div className="min-h-screen bg-background text-on-surface font-body overflow-x-hidden">
      <SEO
        title={seo.title.replace(' | Pulpit', '').replace('Pulpit - ', '')}
        description={seo.description}
        keywords={seo.keywords}
      />
      <Schema type="organization" />
      <Navbar page="corporate" />
      <main className="corporate text-[16px]">
        <Hero />        <StatsBar />
        <SectionTransition from="surface-container-low" to="surface" />
        <ValueProps />
        <SectionTransition from="surface" to="surface-container-lowest" />
        <SafetySection />
        <SectionTransition from="surface-container-lowest" to="surface-container-low" />
        <ServicesSection />
        <SectionTransition from="surface-container-low" to="white" />
        <FleetShowcase />
        <SectionTransition from="white" to="surface-container-low" />
        <TechSection />
        <SectionTransition from="surface-container-low" to="surface" />
        <PricingSection />
        <SectionTransition from="surface" to="surface-container-lowest" />
        <CoverageSection />
        <SectionTransition from="surface-container-lowest" to="surface-container-lowest" />
        <Testimonials />
        <SectionTransition from="surface-container-lowest" to="surface" />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Corporate;
